import React, { Component } from 'react';
import Layout from '../../Layouts/DefaultLayoutNoFooter';
import { Link } from 'react-router-dom';
import { MLInput, Alert } from '../../Components';
import '../../Styles/css/maintenance.css';  //maintenance page changes-allowedemails

class LoginViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            error: "",
            success: "",
            email: "",
            status: 0,   //maintenance page changes
            message: '',  //maintenance page changes
            maintenanceObj: [], //maintenance page changes
            allowedEmails : '' //maintenance page changes-allowedemails
        }
    }

    componentDidMount = async () => {
        this._handleURLAuthentication();
        this.checkMaintenance(); //maintenance page changes
    }

    //maintenance page changes
    checkMaintenance = async() => {
        const formdata0={"period":0};
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/checkmaintenance`, {
            timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(formdata0)
          })
          .then(res => res.json())
          .then(async response => {
            this.setState({maintenanceObj:response});
            if(this.state.maintenanceObj.length > 0)
            {
                this.setState({message: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].message : ''});
                this.setState({status: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].status: 0});
                this.setState({allowedEmails: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].allowemailids:''}); //maintenance page changes-allowedemails
            }
            else
            {
                this.setState({message:''});
                this.setState({status:0});
                this.setState({allowedEmails:''}); //maintenance page changes-allowedemails
            }
        })
    }


    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isLoading_auth == true && nextProps.isLoading_auth == false) {         
            if (nextProps.isAuthenticated === true) {
                try {
                    const urlredirect = this.props.history.location.search;
                    if (urlredirect !== null && urlredirect !== undefined) {
                        const queryparms = new URLSearchParams(urlredirect);
                        if (queryparms.has("redirect")) {
                            const redirect = queryparms.get("redirect");
                            this.props.history.push(`${decodeURIComponent(redirect)}`);
                        } else {
                            throw new Error("redirect not found");
                        }
                    } else {
                        throw new Error("redirect not found");
                    }

                } catch (error) {
                    this.props.history.push(`/`);
                }


            } else {    
                if (nextProps.error !== "") {                    
                    this.setState({
                        error: nextProps.error
                    });
                } 
                else {                    
                    if(typeof(this.state.email) == 'undefined' || this.state.email == null || this.state.email == "")
                    {
                       // NOTHING
                    } else
                    {
                        this.setState({
                            email: "",
                            success: "Login link has been sent to your email",
                            error: ""
                        });
                    }
                }

            }
        }

        return true;
    }

    _handleURLAuthentication = async () => {
        
            try {
                const urltoken = this.props.history.location.search;

                if (urltoken !== null && urltoken !== undefined) {
                    let token = "";
                    const queryparms = new URLSearchParams(urltoken);
                    if (queryparms.has("key")) {
                        token = decodeURIComponent(queryparms.get("key"));
                        await this.props.validateusertoken(token);
                    } else {
                        throw new Error("Token not found");
                    }


                } else {
                    throw new Error("Token not found");
                }
            } catch (error) {
                if(this.props.isAuthenticated){
                    this.props.history.push(`/`); 
                }else{
                    let userid = this.props.match.params.userid;
                    let code = this.props.match.params.code;
    
                    await this.props.userlogin_via_Link(userid, code);
                }
                
            }



        
    }

    _hideMessage = () => {
        this.setState({ error: "", success: "" })
    }

    //maintenance page changes-allowedemails
    _onSubmit = async (e) => {
        e.preventDefault();  
        if ((this.state.email !== "") && (this.state.maintenanceObj.length == 0)) {
            
            let obj = {};
            obj['email'] = this.state.email;
            obj['env'] = process.env.NODE_ENV;
            obj['sitetype'] = process.env.REACT_APP_MODE;
            await this.props.requestUserLogin(obj);
            } else if(this.state.allowedEmails.split(",").includes(this.state.email)){
            let obj = {};
            obj['email'] = this.state.email;
            obj['env'] = process.env.NODE_ENV;
            obj['sitetype'] = process.env.REACT_APP_MODE;
            await this.props.requestUserLogin(obj);
        }
        else
        {

        }
    }

    /*Commented for maintenance page changes-allowedemails*/
    /*
     _onSubmit = async (e) => {
        e.preventDefault();
        if (this.state.email !== "") {
            let obj = {};
            obj['email'] = this.state.email;
            obj['env'] = process.env.NODE_ENV;
            obj['sitetype'] = process.env.REACT_APP_MODE;
            await this.props.requestUserLogin(obj);
        } else {

        }
    }
    */

    _handleonchange = (e) => {
        this.setState({
            email: e.target.value
        })
    }


    render = () => {
    const {maintenanceObj} = this.state; //maintenance page changes
        return (
        <Layout className="inner-page">
            <div className="container-fluid login-container ">
                <div className="row "> 
                    {/*<div className="col-md-12 login-column login-column--primary">*/}  {/*Comments: commented, Modified By: <Asar>, Date Modified: <2020-02-14>*/}
                    <div className="col-md-12 login-column login-column--primary d-flex justify-content-center" style={{textAlign:'center'}}>  {/*Comments: 5G Login text Centre Aligned, Modified By: <Asar>, Date Modified: <2020-02-14>*/}

                     {/*maintenance page changes*/}
                     {(maintenanceObj.length>0) && (maintenanceObj[0].status == 1) && (
                    <div className="column-inner">
                        <p className="maintenance-textcolor maintenance-textalign">CPaaS SEA portal under maintenance!</p>  {/*maintenance page changes-allowedemails - css added*/}
                        <p className="maintenance-textcolor">   {/*maintenance page changes-allowedemails - css added*/}
                            {maintenanceObj.length > 0 ?  maintenanceObj[0].message  : ''}
                        </p>
                        {/* <img src="./assets/logo-white.svg" width="100" className="mb-4" />
                            <br/><br/> */}
                            <h1 style={{fontSize:'50px'}}>Bridge CPaaS</h1>                         
                            <h1>Sales Enablement Academy Portal</h1>
                            <br/>
                            <h3>Member Login</h3>  
                            {
                            this._renderLogin(this.props.isLoading_auth)
                            }
                    </div>
                     )} 
                     {/*maintenance page changes*/}

                     {(maintenanceObj.length == 0) && (
                        <div className="column-inner">
                            {/* <img src="./assets/logo-white.svg" width="100" className="mb-4" />
                            <br/><br/> */}
                            <h1 style={{fontSize:'50px'}}>Bridge CPaaS</h1>                         
                            <h1>Sales Enablement Academy Portal</h1>
                            <br/>
                            <h3>Member Login</h3>  
                            {
                            this._renderLogin(this.props.isLoading_auth)
                            }
                        </div>
                     )}
                    </div>
                </div> 
            </div>
        </Layout>       
        );
    };

    _renderLogin = loading => {
        return (
            <form onSubmit={this._onSubmit}>
                {(this.state.error !== "") && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {this.state.error}
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this._hideMessage}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                {(this.state.success !== "") && (
                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                        {this.state.success}
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this._hideMessage}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <div className="form-group d-flex justify-content-center">
                    <MLInput
                        placeholder={"email"}
                        className={"form-control textboxwidth"}
                        type={"email"}
                        onChange={this._handleonchange}
                        value={this.state.email}
                    />
                </div>
                <button type="submit" disabled={loading} className="btn btn-primary">Submit</button>
                {
                    loading &&
                    <div className="ml-3 spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                }
               
                <p ><br/><br/>
                    This is a private site reserved for Bridge Alliance members. Enter your email address to receive a one-time access link to the site.
                </p>
                <p >
                    If you are not a registered user, <b><Link to="/register">request access here. </Link></b>
                </p>
            </form>
        )
    }

}


/* Export Component ==================================================================== */
export default LoginViewContainer;